import { Editor } from '@tiptap/react'
import { Flex } from 'antd'

import { BlockquoteButton } from './BlockquoteButton'
import { CodeBlockButton } from './CodeBlockButton'
import { EmojiButton } from './EmojiButton'
import { HorizontalRuleButton } from './HorizontalRuleButton'
import { SourceCodeButton } from './SourceCodeButton'

type Props = {
  editor: Editor
}

export const MenuFormatButtons = ({ editor }: Props) => {
  return (
    <Flex gap="8px">
      <BlockquoteButton editor={editor} />
      <CodeBlockButton editor={editor} />
      <HorizontalRuleButton editor={editor} />
      <EmojiButton editor={editor} />
      <SourceCodeButton editor={editor} />
    </Flex>
  )
}
